import React from 'react';
import PropTypes from 'prop-types';

import { Button } from '@sopranodesign/pulse-components';

import { useButtons } from '../../hooks/index';

const DeleteButton = ({ index }) => {
  const { handleButtonDelete } = useButtons();

  return (
    <Button
      variant="secondary"
      colour="danger"
      icon="trash"
      data-testid="delete-button"
      onClick={() => handleButtonDelete(index)}>
      Delete
    </Button>
  );
};

DeleteButton.propTypes = {
  index: PropTypes.number.isRequired
};

export default DeleteButton;
